import { Avatar, Dialog, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { userIsPaidTeamMember, pluralize } from 'lib/helpers';
import { imageAvatarUrl } from 'lib/utils/imageUtils';
import { useCurrentUser } from 'lib/contexts/ApplicationState';
import { User } from 'lib/types/users';
import { ProfileLink } from 'components/ProfileLink';
import { TeamFeatureButton } from 'components/TeamFeatureButton';
import { useRouter } from 'next/router';
import { TeamsProvider } from 'lib/contexts/teamsContext';

interface Props {
  leads?: User[];
  onClose: () => void;
}

export const JobLeadsModal = ({ leads, onClose }: Props) => {
  const currentUser = useCurrentUser();
  const router = useRouter();

  const fakeNameOptions = [
    'YouReallyThought ThisWouldWork',
    'NiceTry ButNope',
    'NotGonnaGiveYou ThisInfo',
    'Upgrade ToSeeLeads',
    'Lead NameHidden',
  ];

  const shouldBlur = userIsPaidTeamMember(currentUser, currentUser?.teams);
  const displayName = (lead: User) => (shouldBlur
    ? fakeNameOptions[Math.floor(Math.random() * fakeNameOptions.length)]
    : lead.name);

  return (
    <TeamsProvider>
      <Dialog open onClose={onClose} fullWidth maxWidth="sm">
        <div className="p-6">
          <div className="absolute right-2 top-2">
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </div>
          <h2 className="text-2xl font-semibold mb-2">External Leads</h2>
          <p className="mb-4 text-sm">
            {leads?.length}
            {' '}
            {pluralize('user', leads?.length)}
            {' '}
            {pluralize('has', leads?.length, 'have')}
            {' '}
            clicked the external application link.
          </p>
          {shouldBlur && (
            <TeamFeatureButton
              className="btn-secondary m-2 mb-6"
              onSuccess={(teamId) => {
                router.push(`/teams/${teamId}/billing`);
              }}
              title="Upgrade to access job leads"
            />
          )}
          {leads && leads.length > 0 ? (
            leads.map((lead) => (
              <div key={lead.id} className={`flex items-center gap-4 mb-4 ${shouldBlur ? 'blur-sm' : ''}`}>
                <Avatar alt={lead.name} src={imageAvatarUrl(lead.avatarUrl, 50)} />
                <ProfileLink
                  user={lead}
                  username={lead.username}
                  linkToExplore={lead.isHidden}
                  disabled={shouldBlur}
                >
                  {displayName(lead)}
                </ProfileLink>
              </div>
            ))
          ) : (
            <div>No external leads yet.</div>
          )}
          <div className="flex justify-end mt-6">
            <button className="btn-secondary" type="button" onClick={onClose}>Close</button>
          </div>
        </div>
      </Dialog>
    </TeamsProvider>
  );
};
